import { useTranslation } from "react-i18next";
import { services } from "@/mocks/about";

export default function ServicesSection() {
  const { t } = useTranslation();

  return (
    <section className="section-padding bg-graphite">
      <div className="container-main">
        <div className="text-center max-w-2xl mx-auto mb-12 md:mb-16">
          <span className="tag-label mb-4 inline-block">{t("about.services.label")}</span>
          <h2 className="text-white mb-4">{t("about.services.title")}</h2>
          <p className="text-cream/70 text-[1.0625rem]">{t("about.services.subtitle")}</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 lg:gap-6">
          {/* First 3 cards */}
          {services.slice(0, 3).map((s, i) => (
            <div
              key={s.id}
              className="bg-slate-blue/50 rounded-xl p-7 md:p-8 border border-white/10 transition-all duration-500 hover:bg-slate-blue/70 hover:-translate-y-2 group"
              style={{ animationDelay: `${i * 100}ms` }}
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-champagne/15 mb-5 transition-all duration-300 group-hover:scale-110 group-hover:bg-champagne/25">
                <i className={`${s.icon} text-2xl text-champagne transition-transform duration-300 group-hover:scale-110`} />
              </div>
              <h3 className="text-white text-[1.25rem] md:text-[1.375rem] mb-1">{t(s.titleKey)}</h3>
              <p className="text-champagne text-base font-sans font-medium mb-3">{t(s.subtitleKey)}</p>
              <p className="text-cream/70 text-[1rem] mb-0">{t(s.descKey)}</p>
            </div>
          ))}
          {/* Last 2 cards span wider on desktop */}
          <div className="md:col-span-2 lg:col-span-3 grid grid-cols-1 md:grid-cols-2 gap-5 lg:gap-6">
            {services.slice(3, 5).map((s, i) => (
              <div
                key={s.id}
                className="bg-slate-blue/50 rounded-xl p-7 md:p-8 border border-white/10 transition-all duration-500 hover:bg-slate-blue/70 hover:-translate-y-2 group"
                style={{ animationDelay: `${(i + 3) * 100}ms` }}
              >
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-champagne/15 mb-5 transition-all duration-300 group-hover:scale-110 group-hover:bg-champagne/25">
                  <i className={`${s.icon} text-2xl text-champagne transition-transform duration-300 group-hover:scale-110`} />
                </div>
                <h3 className="text-white text-[1.25rem] md:text-[1.375rem] mb-1">{t(s.titleKey)}</h3>
                <p className="text-champagne text-base font-sans font-medium mb-3">{t(s.subtitleKey)}</p>
                <p className="text-cream/70 text-[1rem] mb-0">{t(s.descKey)}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}